__webpack_require__.p = "/prayer-times-app/";